import React from 'react';
import Box from '@mui/material/Box';
import Head from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import styled from '@mui/system/styled';

const TableHead = ({headCells, orderBy, order, onRequestSort, noSort}) => {
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <Head>
      <TableRow sx={{bgcolor: 'tertiary600'}}>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sx={{minWidth: '10rem'}}>
            <TableLabel
              hideSortIcon={true}
              active={false}
              // className={orderBy === headCell.id && 'active'}
              // direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}>
              {headCell.label}
              {/* {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null} */}
            </TableLabel>
          </TableCell>
        ))}
      </TableRow>
    </Head>
  );
};

const TableLabel = styled(TableSortLabel)`
  color: rgba(255, 255, 255, 0.7);
  &:hover {
    color: #fff;
  }

  &-webkit-tap-highlight-color {
    color: red;
  }

  &.Mui-active {
    color: #fff;
    font-weight: bold;

    .MuiTableSortLabel-icon {
      color: white;
    }
  }
`;

export default TableHead;
